import { useEmbeddedAuth } from '@src/contexts/embedded-auth/useEmbeddedAuth';
import { useEffect } from 'react';

function SignOut() {
  const { logout } = useEmbeddedAuth();
  useEffect(() => {
    logout();
  }, [logout]);

  return null;
}

export default SignOut;
